module.exports = __webpack_public_path__ + "static/img/02344_4.ce1431e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_4.jpg
// module id = Pujk
// module chunks = 1